import styled, { css } from "styled-components"
import { motion } from "framer-motion"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function Toast({ iconName, desc, top, bottom }) {
  const animation = {
    hidden: {
      opacity: 0,
      translateY: "30%",
      transition: {
        delay: 0,
        duration: 0.3,
      },
    },
    show: {
      opacity: 1,
      translateY: "100%",
      transition: {
        delay: 0,
        duration: 0.3,
      },
    },
  }
  return (
    <ToastBlock
      variants={animation}
      initial="hidden"
      animate="show"
      exit="hidden"
      top={top}
      bottom={bottom}
    >
      {iconName && (
        <IconBlock>
          <SVGIcon name={iconName} />
        </IconBlock>
      )}
      <Description>{desc}</Description>
    </ToastBlock>
  )
}
//calc(100vw * (45 / 375))
const ToastBlock = styled(motion.div)`
  position: absolute;
  top: ${({ top }) => (top ? `calc(100vw * (${top} / 375))` : `0`)};
  right: 0;
  left: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: calc(100vw * (18 / 375)) calc(100vw * (17 / 375));
  margin-right: calc(100vw * (8 / 375));
  margin-left: calc(100vw * (8 / 375));
  background-color: rgba(18, 18, 18, 0.8);
  border-radius: calc(100vw * (8 / 375));
  z-index: 99999;
  ${({ bottom }) =>
    bottom &&
    css`
      bottom: calc(100vw * (${bottom} / 375));
    `};
`

const IconBlock = styled.div`
  width: calc(100vw * (20 / 375));
  height: calc(100vw * (20 / 375));
  margin-right: calc(100vw * (14 / 375));
  svg {
    color: #fff;
  }
`

const Description = styled.p`
  font-family: "Noto Sans KR";
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  color: #fff;
`
